<template>
  <div>
    <list-jenjang ref="jenjang" @kriteria="onKriteria" @detail="onDetail" @kuota="onKuota" />
    <base-modal-full
      generalError
      :autoClose="formulir.mode === 'detail'"
      ref="modal"
      :title="formulir.title"
      :mode="formulir.mode"
    >
      <component
        ref="component"
        :mode="formulir.mode"
        :is="formulir.form"
        :initValue="formulir.init"
        :type="formulir.type"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import ListJenjang from '../base/ListJenjang';
import FormKriteria from '../seleksi/form/Kriteria';
import FormKuota from '../seleksi/form/Kuota';
import DetailPenilaian from '../seleksi/detail/Penilaian';
export default {
  name: 'seleksi-index',
  mixins: [list],
  components: { ListJenjang, FormKriteria, FormKuota, DetailPenilaian },
  data() {
    return {
      formulir: {},
    };
  },

  methods: {
    ...mapActions('peringkat', ['detail', 'save']),

    async onKriteria(jenjang) {
      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'form', 'FormKriteria');
      this.$set(this.formulir, 'title', '1. Set Kriteria - Detail Bobot Kriteria Penilaian');
      this.$set(this.formulir, 'init', {});
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.component.reset();
        this.$set(this.formulir, 'init', Object.assign({}, jenjang));
      });
    },

    async onDetail(options) {
      const titles = {
        nilai: '2. Set Penilaian - Detail Borang Penilaian Kepala Sekolah',
        peringkat: '3. Set Prioritas - Detail Borang Penilaian Kepala Sekolah',
      };

      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'form', 'DetailPenilaian');
      this.$set(this.formulir, 'title', titles[options.type]);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'type', options.type);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$set(this.formulir, 'init', options.jenjang);
        this.$refs.component.reset();
      });
    },

    async onKuota(options) {
      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'form', 'FormKuota');
      this.$set(this.formulir, 'title', '4. Finalisasi Peringkat');
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.component.reset();
        this.$set(this.formulir, 'init', Object.assign({}, options.jenjang, { instansi: options.instansi }));
      });
    },
  },
};
</script>

<style scoped></style>
